var render = function render() {
  var _vm$channel$_vm$userI;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "reporters",
    class: {
      active: _vm.showRightAside && !_vm.showQuestionerScreen,
      isFullScreen: _vm.showFullScreen,
      showChat: _vm.showRightAside
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isAllScreen && _vm.shareInfo.rtilCode,
      expression: "isAllScreen && shareInfo.rtilCode"
    }],
    staticClass: "share-box flex"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v(_vm._s(_vm.nameList[_vm.shareInfo.initiator]) + " " + _vm._s(_vm.$t('partylineGuest.isSharing')))]), _c('span', {
    staticClass: "check-share pointer",
    on: {
      "click": _vm.checkScreen
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('commonFunction.switchToParty')) + " ")])])]), _c('div', {
    staticClass: "hide"
  }, [_vm._v(_vm._s(_vm.spearkInfo))]), _c('div', {
    staticClass: "speaker",
    class: {
      isFullScreen: _vm.showSpeakerFullScreen,
      notShowFootBar: !_vm.State.showFootBar,
      showChat: _vm.showRightAside
    }
  }, [_c('NewAttendUser', {
    staticClass: "is-speaker",
    attrs: {
      "title": _vm.outputId == _vm.spearkInfo.id ? '' : _vm.spearkInfo.tid,
      "nickName": _vm.nameList[_vm.spearkInfo.id],
      "singChannel": _vm.spearkInfo,
      "isShare": false,
      "userInfo": _vm.userInfo,
      "rtc": _vm.rtc,
      "isAudioLevel": _vm.isAudioLevel,
      "volume": _vm.voiceList[_vm.spearkInfo.id],
      "degreeHost": _vm.degreeHost[_vm.spearkInfo.id],
      "showChat": _vm.showRightAside,
      "muteVideo": _vm.outputId == _vm.spearkInfo.id ? false : !_vm.State.cameraStatus[_vm.spearkInfo.id],
      "muteAudio": _vm.outputId == _vm.spearkInfo.id ? false : !_vm.State.micStatus[_vm.spearkInfo.id],
      "showMuteIcons": _vm.outputId == _vm.spearkInfo.id ? false : true,
      "notShowPraviteBg": true
    },
    on: {
      "callback": _vm.attendCallback
    }
  }, [!_vm.userInfo.status.speaker && !_vm.userInfo.status.output ? _c('div', {
    staticClass: "defaultBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoGray
    }
  }), _c('div', [_vm._v(_vm._s(_vm.$t('conferenceHost.noSpeakerMessage')))])]) : _vm._e(), _c('div', {
    staticClass: "speakerTitle"
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.Speaker')))])])], 1), _c('div', {
    staticClass: "reporter",
    class: {
      active: _vm.showRightAside
    }
  }, [_vm.shareInfo.rtilCode ? _c('div', {
    staticClass: "videos",
    class: {
      isFullScreen: _vm.showShareFullScreen,
      notShowFootBar: !_vm.State.showFootBar,
      showChat: _vm.showRightAside
    }
  }, [_vm.shareInfo.rtilCode ? _c('NewAttendUser', {
    staticClass: "shareBox",
    attrs: {
      "title": _vm.shareList.tid,
      "nickName": _vm.nameList[_vm.spearkInfo.id],
      "singChannel": _vm.shareList,
      "isShare": true,
      "rtc": _vm.rtc,
      "volume": _vm.voiceList[_vm.shareList.id],
      "degreeHost": _vm.degreeHost[_vm.shareList.id],
      "showChat": _vm.showRightAside,
      "isallScrren": _vm.isAllScreen,
      "shareInfo": _vm.shareInfo,
      "isAudioLevel": _vm.isAudioLevel,
      "userInfo": _vm.userInfo,
      "muteVideo": !_vm.State.cameraStatus[_vm.shareList.id],
      "muteAudio": !_vm.State.micStatus[_vm.shareList.id],
      "showMuteIcons": false
    },
    on: {
      "callback": _vm.attendCallback
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.userInfo.status.questionSpeaker && _vm.userInfo.status.questionSpeaker != _vm.userInfo.rtilCode ? _c('div', {
    staticClass: "videos",
    class: {
      isFullScreen: _vm.showQuestionerScreen,
      notShowFootBar: !_vm.State.showFootBar,
      showChat: _vm.showRightAside
    }
  }, [_c('span', {
    staticClass: "tipIcon"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Interviewer",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-universal_interviewer"
  })])], 1), _c('NewAttendUser', {
    class: {
      'host-questionSpeaker': _vm.questionInfo.id == _vm.managerRtil
    },
    attrs: {
      "title": _vm.questionInfo.tid,
      "nameColor": _vm.questionInfo.id == _vm.userInfo.status.questionSpeaker ? 'green' : '',
      "nickName": _vm.nameList[_vm.questionInfo.id],
      "singChannel": _vm.questionInfo,
      "isShare": false,
      "rtc": _vm.rtc,
      "volume": _vm.voiceList[_vm.questionInfo.id],
      "degreeHost": _vm.degreeHost[_vm.questionInfo.id],
      "showChat": _vm.showRightAside,
      "userInfo": _vm.userInfo,
      "isAudioLevel": _vm.isAudioLevel,
      "muteVideo": !_vm.State.cameraStatus[_vm.questionInfo.id],
      "muteAudio": !_vm.State.micStatus[_vm.questionInfo.id],
      "talkInfo": {
        rtilCode: _vm.questionInfo.id
      }
    },
    on: {
      "callback": _vm.attendCallback
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "videos",
    class: {
      isFullScreen: _vm.showQuestionerScreen || _vm.showFullScreen,
      notShowFootBar: !_vm.State.showFootBar,
      showChat: _vm.showRightAside
    }
  }, [_vm.userInfo.role == 5 || _vm.userInfo.role == 3 ? _c('span', {
    staticClass: "tipIcon"
  }, [_vm.userInfo.role == 5 ? _c('i', {
    staticClass: "iconfont icon-universal_interviewer"
  }) : _vm._e(), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.waitText,
      "placement": "top"
    }
  }, [_c('span', [_vm.userInfo.role == 3 ? _c('i', {
    staticClass: "iconfont icon-questionerqueue"
  }) : _vm._e(), _vm.waitNum <= 3 && _vm.userInfo.role == 3 ? _c('span', {
    staticClass: "waitNum"
  }, [_vm._v(" " + _vm._s(_vm.waitNum))]) : _vm._e()])])], 1) : _vm._e(), !_vm.noCameras ? _c('NewAttendUser', {
    ref: "localVideo",
    staticClass: "is-local bottomTitle",
    class: {
      questioner: _vm.userInfo.role == 3,
      praivate: _vm.State.privateInfo.rtilCode == _vm.userId,
      'host-questionSpeaker': _vm.questionInfo.id == _vm.managerRtil
    },
    attrs: {
      "nameColor": _vm.userInfo.role == 5 ? 'green' : '',
      "title": "Me",
      "nickName": _vm.nameList[_vm.userId],
      "organization": _vm.organizationList[_vm.userId],
      "isShare": false,
      "rtc": _vm.rtc,
      "volume": _vm.voiceList[_vm.userId],
      "showChat": _vm.showRightAside,
      "controlMute": true,
      "singChannel": _vm.MeInfo,
      "talkInfo": {
        rtilCode: _vm.userInfo.role == 5 ? _vm.userId : ''
      },
      "userInfo": _vm.userInfo,
      "isAudioLevel": _vm.isAudioLevel,
      "liveInfo": _vm.liveInfo[_vm.userId] || {},
      "muteVideo": !_vm.State.cameraStatus[_vm.userId],
      "muteAudio": !_vm.State.micStatus[_vm.userId],
      "degreeHost": _vm.degreeHost[_vm.userInfo.rtilCode],
      "privateIsOnlyShowMe": true,
      "lockName": _vm.lockName,
      "operateList": _vm.lockName ? ['fullScreen'] : ['fullScreen', 'rename']
    },
    on: {
      "callback": _vm.attendCallback
    }
  }, [_c('div', {
    class: _vm.returnVideoClass,
    attrs: {
      "id": "local_stream"
    }
  })]) : _vm._e()], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }]
  }, [_vm.channel[_vm.userInfo.status.managerRtil] && _vm.State.privateInfo.rtilCode == _vm.userId && (!_vm.spearkInfo.id || _vm.spearkInfo.id && _vm.spearkInfo.id != _vm.userInfo.status.managerRtil) ? _c('NewAttendUser', {
    attrs: {
      "title": (_vm$channel$_vm$userI = _vm.channel[_vm.userInfo.status.managerRtil].tid) === null || _vm$channel$_vm$userI === void 0 ? void 0 : _vm$channel$_vm$userI.toUpperCase(),
      "singChannel": _vm.channel[_vm.userInfo.status.managerRtil],
      "isShare": false,
      "muteAudio": !_vm.State.micStatus[_vm.userInfo.status.managerRtil],
      "rtc": _vm.rtc,
      "userInfo": _vm.userInfo
    }
  }) : _vm._e()], 1), _vm.setNameInfo.show ? _c('user-setting', {
    attrs: {
      "info": _vm.setNameInfo
    },
    on: {
      "setNickName": _vm.setNickName
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };